export enum RequestLanguage {
  en = "en",
  vi = "vi",
}

export const requestLanguageDetail: {
  [key in RequestLanguage]: { label: string; flag?: string };
} = {
  [RequestLanguage.en]: {
    label: "Tiếng Anh",
  },
  [RequestLanguage.vi]: {
    label: "Tiếng Việt",
  },
};
